import React from 'react';

type CanvasToolIconProps = {
  className?: string;
};

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true as const,
  focusable: false as const,
};

/** Shared class so {@link Icon} keeps fill + stroke for canvas tools. */
const CANVAS_TOOL_ICON_CLASS = 'nodonCanvasToolIcon';

/**
 * Select cursor — light fill + outline.
 */
export const CanvasSelectIcon: React.FC<CanvasToolIconProps> = ({
  className,
}) => (
  <svg
    {...svgProps}
    className={[CANVAS_TOOL_ICON_CLASS, className].filter(Boolean).join(' ')}
  >
    <path
      d="M5 3.2v16.2l4.1-3.9 2.7 6.4 2.3-1-2.7-6.4H18L5 3.2Z"
      fill="var(--tool-icon-fill)"
      stroke="var(--tool-icon-outline)"
      strokeWidth="1.35"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Open hand for pan — light fill + outline.
 */
export const CanvasPanIcon: React.FC<CanvasToolIconProps> = ({ className }) => (
  <svg
    {...svgProps}
    className={[CANVAS_TOOL_ICON_CLASS, className].filter(Boolean).join(' ')}
  >
    <path
      d="M9.2 11.2V6.9a1.15 1.15 0 0 1 2.3 0v4.1h.05V5.6a1.15 1.15 0 0 1 2.3 0v5.4h.05V6.3a1.15 1.15 0 0 1 2.3 0v7.1c0 2.55-1.85 4.7-4.45 4.7h-.2c-2.15 0-4-1.4-4.65-3.45L6.1 13.2a1.2 1.2 0 0 1 1.7-1.55l1.4.85Z"
      fill="var(--tool-icon-fill)"
      stroke="var(--tool-icon-outline)"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Pen for draw — light fill + outline.
 */
export const CanvasDrawIcon: React.FC<CanvasToolIconProps> = ({
  className,
}) => (
  <svg
    {...svgProps}
    className={[CANVAS_TOOL_ICON_CLASS, className].filter(Boolean).join(' ')}
  >
    <path
      d="M5.2 18.7 6.5 14.1 16.4 4.2a1.55 1.55 0 0 1 2.2 0l1.2 1.2a1.55 1.55 0 0 1 0 2.2L9.9 17.4 5.2 18.7Z"
      fill="var(--tool-icon-fill)"
      stroke="var(--tool-icon-outline)"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3 5.4 18.6 9.7"
      fill="none"
      stroke="var(--tool-icon-outline)"
      strokeWidth="1.35"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Four-way arrows for move — filled heads + outline.
 */
export const CanvasMoveIcon: React.FC<CanvasToolIconProps> = ({
  className,
}) => (
  <svg
    {...svgProps}
    className={[CANVAS_TOOL_ICON_CLASS, className].filter(Boolean).join(' ')}
  >
    <path
      d="M12 3.8 8.9 7.2h2.1v3.7H7.3V8.8L3.9 12l3.4 3.2v-2.1h3.7v3.7H8.9L12 20.2l3.1-3.4h-2.1v-3.7h3.7v2.1L20.1 12l-3.4-3.2v2.1h-3.7V7.2h2.1L12 3.8Z"
      fill="var(--tool-icon-fill)"
      stroke="var(--tool-icon-outline)"
      strokeWidth="1.2"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Measure / ruler — light fill + outline.
 */
export const CanvasMeasureIcon: React.FC<CanvasToolIconProps> = ({
  className,
}) => (
  <svg
    {...svgProps}
    className={[CANVAS_TOOL_ICON_CLASS, className].filter(Boolean).join(' ')}
  >
    <path
      d="M4.6 14.4 14.4 4.6a2 2 0 0 1 2.8 0l2.2 2.2a2 2 0 0 1 0 2.8L9.6 19.4a2 2 0 0 1-2.8 0L4.6 17.2a2 2 0 0 1 0-2.8Z"
      fill="var(--tool-icon-fill)"
      stroke="var(--tool-icon-outline)"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.1 11.4 9.5 12.8M10.5 9 11.9 10.4M12.9 6.6 14.3 8"
      fill="none"
      stroke="var(--tool-icon-outline)"
      strokeWidth="1.35"
      strokeLinecap="round"
    />
  </svg>
);
